export class RestSDKError extends Error {
  constructor(readonly response: Response) {
    super(`RestError: ${response.status} ${response.url}`);

    Object.setPrototypeOf(this, RestSDKError.prototype);
  }
}
